export const NOT_EXISTS = 'NOT_EXISTS'
export const CREATING = 'CREATING'
export const PENDING = 'PENDING'
export const READY = 'READY'
export const DELETED = 'DELETED'
